import { NormalizeOAS, OASRequestParams, OASResponse } from 'fets';
import type assetLibraryOpenApi from '../asset-library-open-api';
import { AssetLibraryFetsApiClient } from '../asset-library-fets-client';
import { assertNever } from '../utils';
import { Guid } from '../../api/public/utils/Guid';

const PATH = '/api/v2/asset-directory/company/{companyId}/create/{parentId}';

type Params = {
  companyId: Guid;
  parentId: Guid;
  name: string;
};

export type Folder = {
  id: Guid;
  name: string;
  parentId: Guid | null;
};

type Result = Folder;

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<Result>;

export const createCreateAssetFolder = (apiClient: AssetLibraryFetsApiClient): ApiFunction => {
  const createAssetFolder = async (params: Params, signal?: AbortSignal): Promise<Result> => {
    const response = await apiClient[PATH].post({
      ...convertToRequest(params),
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return createAssetFolder;
};

type Request = OASRequestParams<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;
type Response = OASResponse<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;

const convertToRequest = (params: Params): Request => ({
  params: { companyId: params.companyId, parentId: params.parentId },
  json: { name: params.name },
});

const convertResponse = async (response: Response): Promise<Result> => {
  const responseStatus = response.status;
  if (responseStatus !== 201) {
    return assertNever(responseStatus);
  }

  const data = await response.json();
  const result: Folder = {
    id: data.id,
    name: data.name,
    parentId: data.parentId ?? null,
  };
  return result;
};
